import { Component } from 'react';
import isObject from 'lodash/isObject';
import ModalModule from '../modal';
import Utils from '../utils';
import SecurityQuestions from './SecurityQuestions.component';

const { ModalContext } = ModalModule;
const {
	Analytics,
	Communication,
	Session,
	Util,
	Logger: { logToServer },
} = Utils;

export default class Auth extends Component {
	componentDidMount() {
		this.authenticateUser();
	}

	authenticateUser = async () => {
		const { showModal, showError } = this.context;
		const { userName, password, loginSource, callback } = this.props;

		const authenticateResponse = await Communication.authenticateUser({
			Username: userName,
			Password: password,
			loginSource,
		});
		const isSuccessful = Communication.isSuccessful(authenticateResponse);
		const brand = Session.getBrand();
		const segmentData = {
			username: userName,
			success: isSuccessful,
			url: window.location.href,
		};

		Analytics.trackEvent('signIn', segmentData, Analytics.agent.segment);

		if (!isSuccessful) {
			logToServer({
				category: 'error_authenticate',
				message: authenticateResponse,
			});
		}

		if (isSuccessful) {
			const time = new Date(new Date().getTime() + 90 * 86400000);
			const codewordsNeeded = isObject(authenticateResponse.data)
				? authenticateResponse.data.codewordsNeeded
				: false;

			Util.setCookie('existingcust', 'true', time);

			if (codewordsNeeded) {
				showModal({
					component: SecurityQuestions,
					data: {
						callback: this.securityQuestionsCallback,
						enumCodewords: authenticateResponse.data.enumCodewords,
					},
				});
			} else {
				callback({ status: true });
			}
		} else if (authenticateResponse.ErrorCode === 1000002) {
			callback({
				status: false,
				errorDescription: 'Your username or password is invalid.',
				errorCode: authenticateResponse.ErrorCode,
			});
		} else if (authenticateResponse.ErrorCode === 1000008) {
			callback({
				status: false,
				errorDescription:
					'Your account has been locked for security reasons due to too many failed login attempts.Please contact your administrator to unlock your account.',
				errorCode: authenticateResponse.ErrorCode,
			});
		} else if (
			authenticateResponse.ErrorCode === 1000010 ||
			authenticateResponse.ErrorCode === 1000012
		) {
			if (authenticateResponse.ErrorCode === 1000012) {
				logToServer({
					category: 'page_error',
					message: 'MeterID 0',
				});
			}

			callback({
				status: false,
				errorDescription: `It appears you are having trouble logging into your account. Please contact Customer Support for assistance at: ${
					authenticateResponse.ErrorCode === 1000010
						? Util.getFraudNumber(brand)
						: brand.contactPhoneNumber
				}`,
				errorCode: authenticateResponse.ErrorCode,
			});
		} else if (authenticateResponse.ErrorCode === 1000009) {
			const { history } = this.props;
			history.push(
				`/resetpassword?username=${userName}&tempPw=${Util.getQueryParamByName('tempPw')}`
			);
		} else {
			showError({ response: authenticateResponse });
			callback({
				status: false,
				errorDescription: authenticateResponse.ErrorDescription,
				errorCode: authenticateResponse.ErrorCode,
			});
		}
	};

	securityQuestionsCallback = status => {
		if (status) {
			this.authenticateUser();
		}
	};

	render() {
		return null;
	}
}

Auth.contextType = ModalContext;
